export default "__VITE_ASSET__Bpn$3kbF__"